import { render, staticRenderFns } from "./SymbolColorPicker.vue?vue&type=template&id=92ec1046&scoped=true&"
import script from "./SymbolColorPicker.vue?vue&type=script&lang=js&"
export * from "./SymbolColorPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ec1046",
  null
  
)

export default component.exports